import { openPopup } from '../functions/popups'; 

export const newsletter = () => {
    const footerTriggers = document.querySelectorAll('.js-newsletter-trigger');

    if ( footerTriggers.length > 0 ) {
        footerTriggers.forEach(footerTrigger => {
            footerTrigger.addEventListener('click', (event) => {
                event.preventDefault();

                const emailAddress = footerTrigger.previousElementSibling.value;
                const signupEmailField = document.querySelector('.js-newsletter-email');

                if ( signupEmailField ) {
                    signupEmailField.value = emailAddress;
                }

                openPopup('#newsletter');
            });
        });
    }
}